<template>
  <div v-if="authjson.authjson(['9-5', '9-6'])">
    <div class="c_top_title">{{ $t("bank_card.Cards_List") }}</div>

    <div class="t_h1">
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top">
          <el-form-item>
            <el-input
              v-model="form.card_name"
              :placeholder="$t('bank_card.Please_enter_name')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.card_email"
              :placeholder="$t('bank_card.Please_enter_email')"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-select v-model="form.kyc_status" :placeholder="$t('bank_card.state')">
              status:  ,//状态 0 未提交 1 Pending  2 processing  3 approved 4 rejected  5 active   6 blocked 7 kyc_approved
              <el-option :label="$t('bank_card.uncommitted')" value="0"></el-option>
              <el-option :label="$t('bank_card.approved')" value="1"></el-option>
              <el-option :label="$t('main.text587')" value="2"></el-option>
              <el-option :label="$t('bank_card.approved')" value="3"></el-option>
              <el-option :label="$t('bank_card.rejected')" value="4"></el-option>
              <el-option :label="$t('bank_card.active')" value="5"></el-option>
              <el-option :label="$t('bank_card.blocked')" value="6"></el-option>
              <el-option :label="$t('bank_card.kyc_approved')" value="7"></el-option>
              <el-option :label="$t('bank_card.Cancelled')" value="8"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-select
              v-model="form.account_status"
              :placeholder="$t('bank_card.Subaccount_status')"
            >
              <el-option
                :label="$t('bank_card.status_1')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('bank_card.KYC_Processing')"
                value="2"
              ></el-option>
              <el-option
                :label="$t('new3_txt.P_Resubmission')"
                value="4"
              ></el-option>
              <el-option
                :label="$t('new3_txt.KYC_Rejected')"
                value="19"
              ></el-option>
              <el-option
                :label="$t('bank_card.kyc_approved')"
                value="3"
              ></el-option>
              <el-option
                :label="$t('bank_card.mailed_s')"
                value="10"
              ></el-option>
              <el-option
                :label="$t('bank_card.Card_anomaly')"
                value="11"
              ></el-option>
              <el-option
                :label="$t('bank_card.Activated')"
                value="6"
              ></el-option>
              <!-- <el-option :label="$t('bank_card.Refuse_card')" value="12"></el-option> -->
              <el-option
                :label="$t('bank_card.Rep_card')"
                value="13"
              ></el-option>
              <el-option
                :label="$t('bank_card.replacement_card')"
                value="14"
              ></el-option>
              <el-option
                :label="$t('bank_card.Reissued_card')"
                value="15"
              ></el-option>
              <el-option
                :label="$t('bank_card.Cancelling')"
                value="18"
              ></el-option>
              <el-option
                :label="$t('bank_card.Cancelled')"
                value="9"
              ></el-option>
              <el-option :label="$t('bank_card.freeze')" value="8"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="form.card_status"
              :placeholder="$t('new1_txt.card_status')"
            >
              <el-option :label="$t('bank_card.forbidden')" value="1" ></el-option>
              <el-option :label="$t('main.text588')" value="2" ></el-option>
              <el-option :label="$t('main.text589')" value="3" ></el-option>
              <el-option :label="$t('bank_card.Cancelled')" value="4" ></el-option>
              <el-option :label="$t('beth_text.Expired')" value="5" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="form.op_status"
              :placeholder="$t('bank_card.Operation_Status')"
            >
              <el-option
                :label="$t('bank_card.status_1')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('bank_card.KYC_Processing')"
                value="2"
              ></el-option>
              <el-option
                :label="$t('new3_txt.P_Resubmission')"
                value="4"
              ></el-option>
              <el-option
                :label="$t('new3_txt.KYC_Rejected')"
                value="19"
              ></el-option>
              <el-option
                :label="$t('bank_card.kyc_approved')"
                value="3"
              ></el-option>
              <el-option
                :label="$t('bank_card.Consolidating')"
                value="16"
              ></el-option>
              <el-option
                :label="$t('bank_card.Printing')"
                value="7"
              ></el-option>
              <el-option
                :label="$t('bank_card.Card_Binded2')"
                value="5"
              ></el-option>
              <el-option
                :label="$t('bank_card.mailed_s')"
                value="10"
              ></el-option>
              <el-option
                :label="$t('bank_card.Card_anomaly')"
                value="11"
              ></el-option>
              <el-option
                :label="$t('bank_card.Activated')"
                value="6"
              ></el-option>
              <!-- <el-option :label="$t('bank_card.Refuse_card')" value="12"></el-option> -->
              <el-option
                :label="$t('bank_card.Rep_card')"
                value="13"
              ></el-option>
              <el-option
                :label="$t('bank_card.replacement_card')"
                value="14"
              ></el-option>
              <el-option
                :label="$t('bank_card.Reissued_card')"
                value="15"
              ></el-option>
              <el-option
                :label="$t('bank_card.Pending_Rebind')"
                value="17"
              ></el-option>
              <el-option
                :label="$t('bank_card.Cancelling')"
                value="18"
              ></el-option>
              <el-option
                :label="$t('bank_card.Cancelled')"
                value="9"
              ></el-option>
              <el-option :label="$t('bank_card.freeze')" value="8"></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item>
            <el-select v-model="card_array" :placeholder="$t('bank_card.card_array')">
              <el-option v-for="item in card_array_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item>
            <el-select
              v-model="card_level"
              :placeholder="$t('bank_card.card_level')"
            >
              <el-option
                v-for="item in card_level_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="card_type"
              :placeholder="$t('bank_card.Card_class')"
            >
              <el-option
                v-for="item in card_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item>
            <el-select v-model="form.card_category" :placeholder="$t('bank_card.Card_class')">
              1 VISA 2 Mastercard 3 UnionPay
              <el-option :label="$t('bank_card.VISA')" value="1"></el-option>
              <el-option :label="$t('bank_card.Mastercard')" value="2"></el-option>
              <el-option :label="$t('bank_card.UnionPay')" value="3"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-input
              v-model="form.card_number"
              :placeholder="$t('bank_card.card_number')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.print_number"
              :placeholder="$t('bank_card.Print_batch_number')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.username"
              :placeholder="$t('bank_card.Username')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.kit_number"
              :placeholder="$t('bank_card.kit_number')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.visionLife_id"
              :placeholder="$t('bank_card.Client_Ref_ID')"
              v-if="project_name == 'VisionLife'"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="transaction_h">
      <div class="contract_m_top">
        <div class="c_top_title"></div>
      </div>

      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">
              {{ $t("bank_card.There") }} {{ total }}
              {{ $t("bank_card.are_records") }}
            </div>
          </div>
          <div>
            <el-button
              v-if="authjson.authjson(['9-19'])"
              class="export_btn border_set_color2"
              size="medium"
              @click="download_btn"
            >
              {{ $t("main.text333") }}
            </el-button>

            <el-button
              v-if="authjson.authjson(['9-12'])"
              class="export_btn border_set_color2"
              size="medium"
              @click="refresh_btn"
            >
              {{ $t("main.text467") }}
            </el-button>

            <el-button
              v-if="authjson.authjson(['9-13'])"
              class="export_btn border_set_color2"
              size="medium"
              @click="go_list"
            >
              <img
                class="btn_icon"
                src="../../assets/img/time_yellow_icon.png"
                alt=""
              />
              {{ $t("main.text580") }}
            </el-button>
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column label="#" type="index" width="60">
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.application_date')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ overall_time2(props.row.create_time) }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Card_name')" min-width="110">
              <span slot-scope="props">
                <div class="next_info" @click="to_info(props.row.card_id)">
                  {{ props.row.card_name }}
                </div>
                <!-- <div>{{ props.row.card_name }}</div> -->
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.email')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.card_email }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text519')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.first_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text520')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.last_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Username')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.username }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Client_Ref_ID')"
              min-width="110"
              v-if="project_name == 'VisionLife'"
            >
              <span slot-scope="props">
                <div>{{ props.row.visionLife_id }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text199')" min-width="140">
              <span slot-scope="props">
                <div>
                  +{{ props.row.calling_code }} {{ props.row.mobile_number }}
                </div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text144')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.country }}</div>
              </span>
            </el-table-column>

            <!-- <el-table-column :label="$t('bank_card.Corporate_Clent')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.company_name }}</div>
              </span>
            </el-table-column> -->

            <!-- <el-table-column :label="$t('bank_card.company_abbreviation')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.company_abbreviation }}</div>
              </span>
            </el-table-column> -->

            <el-table-column
              :label="$t('bank_card.contract_id')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.contract_id }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Card_Fee')" min-width="110">
              <span slot-scope="props">
                  <div v-if="props.row.contract_id">
                    <!-- card_fee_status: , //卡费状态  0 未缴纳  1预缴纳 2已退回 3已缴纳 4pending -->
                    <span v-if="props.row.card_fee_status === 3 && [2,3].includes(props.row.method_type)">{{$t("beth_text.Free_annual_fee")}}</span>
                    <span v-else>
                      <span v-if="props.row.card_fee_status == 0">{{ $t("bank_card.unpaid") }}</span>
                      <span v-else-if="props.row.card_fee_status == 1">{{ $t("bank_card.prepayment") }}</span>
                      <span v-else-if="props.row.card_fee_status == 2">{{ $t("bank_card.unpaid") }}</span>
                      <span v-else-if="props.row.card_fee_status == 3">{{ $t("bank_card.paid") }}</span>
                      <span v-else-if="props.row.card_fee_status == 4">{{ $t("main.text586") }}</span>
                      <span v-else>-</span>
                    </span>
                  </div>
                  <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Annual_Membership')"
              min-width="110"
            >
              <!-- annual_fee_status: , //年费状态   0未缴纳  1预缴纳 2已退回 3已缴纳 4pending -->
              <span slot-scope="props">
                  <div v-if="props.row.contract_id">
                    <span v-if="props.row.method_type == 3">-</span>
                    <span v-else>
                      <span v-if="props.row.annual_fee_status == 0">{{ $t("bank_card.unpaid") }}</span>
                      <span v-else-if="props.row.annual_fee_status == 1">{{ $t("bank_card.prepayment") }}</span>
                      <span v-else-if="props.row.annual_fee_status == 2">{{ $t("bank_card.unpaid") }}</span>
                      <span v-else-if="props.row.annual_fee_status == 3">{{ $t("bank_card.paid") }}</span>
                      <span v-else-if="props.row.annual_fee_status == 4">{{ $t("main.text586") }}</span>
                      <span v-else>-</span>
                    </span>
                  </div>
                  <div v-else>-</div>
              </span>
            </el-table-column>

            <!-- <el-table-column :label="$t('bank_card.card_array')" min-width="120">
              <span slot-scope="props">
                {{ props.row.card_array_name||"-" }}
              </span>
            </el-table-column> -->

            <el-table-column
              :label="$t('bank_card.card_level')"
              min-width="100"
            >
              <span slot-scope="props">
                {{ props.row.card_level_name || "-" }}
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Card_class')"
              min-width="100"
            >
              <span slot-scope="props">
                {{ props.row.card_type_name || "-" }}
              </span>
            </el-table-column>

            <!-- <el-table-column :label="$t('bank_card.branded_card_category')" min-width="110">
              <span slot-scope="props">
                card_category:  //卡类别  1VISA 2Mastercard 3UnionPay
                <span v-if="props.row.card_category==1">{{$t('bank_card.VISA')}}</span>
                <span v-else-if="props.row.card_category==2">{{$t('bank_card.Mastercard')}}</span>
                <span v-else-if="props.row.card_category==3">{{$t('bank_card.UnionPay')}}</span>
                <span v-else>-</span>
              </span>
            </el-table-column> -->

            <!-- 2023-09-12 ppt -->
            <!-- <el-table-column :label="$t('bank_card.delivery_type')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.delivery_type}}</div>
              </span>
            </el-table-column> -->

            <el-table-column
              :label="$t('bank_card.card_number')"
              min-width="145"
            >
              <span slot-scope="props">
                <div>{{ props.row.card_number || "-" }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.kit_number')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.kit_number || "-" }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.print_number')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.print_number }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Date_lssuse')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.issue_date }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Date_Expiry')"
              min-width="110"
            >
              <span slot-scope="props">
                <div>{{ props.row.expire_date }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Subaccount_status')"
              min-width="140"
            >
              <span slot-scope="props">
                <span v-if="props.row.account_status == 1">{{
                  $t("bank_card.status_1")
                }}</span>
                <span v-else-if="props.row.account_status == 2">{{
                  $t("bank_card.KYC_Processing")
                }}</span>
                <span v-else-if="props.row.account_status == 3">{{
                  $t("bank_card.kyc_approved")
                }}</span>
                <span v-else-if="props.row.account_status == 4">{{
                  $t('new3_txt.P_Resubmission')
                }}</span>
                <span v-else-if="props.row.account_status == 5">{{
                  $t("bank_card.Card_Binded2")
                }}</span>
                <span v-else-if="props.row.account_status == 6">{{
                  $t("bank_card.Activated")
                }}</span>
                <span v-else-if="props.row.account_status == 7">{{
                  $t("bank_card.Printing")
                }}</span>
                <span v-else-if="props.row.account_status == 8">{{
                  $t("bank_card.freeze")
                }}</span>
                <span v-else-if="props.row.account_status == 9">{{
                  $t("bank_card.Cancelled")
                }}</span>
                <span v-else-if="props.row.account_status == 10">{{
                  $t("bank_card.mailed_s")
                }}</span>
                <span v-else-if="props.row.account_status == 11">{{
                  $t("bank_card.Card_anomaly")
                }}</span>
                <!-- <span v-else-if="props.row.account_status==12">{{$t('bank_card.Refuse_card')}}</span> -->
                <span v-else-if="props.row.account_status == 13">{{
                  $t("bank_card.Rep_card")
                }}</span>
                <span v-else-if="props.row.account_status == 14">{{
                  $t("bank_card.replacement_card")
                }}</span>
                <span v-else-if="props.row.account_status == 15">{{
                  $t("bank_card.Reissued_card")
                }}</span>
                <span v-else-if="props.row.account_status == 16">{{
                  $t("bank_card.Consolidating")
                }}</span>
                <span v-else-if="props.row.account_status == 17">{{
                  $t("bank_card.Pending_Rebind")
                }}</span>
                <span v-else-if="props.row.account_status == 18">{{
                  $t("bank_card.Cancelling")
                }}</span>
                <span v-else-if="props.row.account_status == 19">{{
                  $t('new3_txt.KYC_Rejected')
                }}</span>
                <span v-else>-</span>

                <span
                  v-if="props.row.status == 6 && props.row.block_orgin != 0"
                >
                  <el-tooltip placement="top">
                    <i class="el-icon-warning-outline icon_question"></i>
                    <div slot="content">
                      <!-- block_orgin: 1, //1前台冻结；2后台冻结；3api冻结 -->
                      <!-- 1  Client Block 2  Admin Block 3  User Block -->
                      <span v-if="props.row.block_orgin == 1">{{
                        $t("bank_card.Client_Block")
                      }}</span>
                      <span v-else-if="props.row.block_orgin == 2">{{
                        $t("bank_card.Admin_Block")
                      }}</span>
                      <span v-else-if="props.row.block_orgin == 3">{{
                        $t("bank_card.User_Block")
                      }}</span>
                    </div>
                  </el-tooltip>
                </span>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('new1_txt.card_status')"
              min-width="110">
              <span slot-scope="props">
                <!-- card_status Inactive、Active、Blocked、Cancelled 、Expired 1/2/3/4/5 -->
                 <span v-if="props.row.card_status==1">{{$t('bank_card.forbidden')}}</span>
                 <span v-else-if="props.row.card_status==2">{{$t('main.text588')}}</span>
                 <span v-else-if="props.row.card_status==3">{{$t('main.text589')}}</span>
                 <span v-else-if="props.row.card_status==4">{{$t('bank_card.Cancelled')}}</span>
                 <span v-else-if="props.row.card_status==5">{{$t('beth_text.Expired')}}</span>
                 <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.op_status_time')"
              min-width="110"
            >
              <span slot-scope="props">
                <div v-if="props.row.op_status_time">
                  {{ overall_time2(props.row.op_status_time) }}
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.Operation_Status')"
              min-width="110"
            >
              <!-- 运营状态1 Pending 2 KYC Processing 3 KYC Approved 4 Rejected 5 Card Binded 
              6 Activated 7 Printing 8 block 9 Cancelled 10 mailed  11 卡异常 12 拒绝补卡 13 申请补卡 
              14 补卡中 15 已补卡 16 Consolidating  17 Pending Rebind -->
              <span slot-scope="props">
                <span v-if="props.row.op_status == 1">{{
                  $t("bank_card.status_1")
                }}</span>
                <span v-else-if="props.row.op_status == 2">{{
                  $t("bank_card.KYC_Processing")
                }}</span>
                <span v-else-if="props.row.op_status == 3">{{
                  $t("bank_card.kyc_approved")
                }}</span>
                <span v-else-if="props.row.op_status == 4">{{
                  $t("new3_txt.P_Resubmission")
                }}</span>
                <span v-else-if="props.row.op_status == 5">{{
                  $t("bank_card.Card_Binded2")
                }}</span>
                <span v-else-if="props.row.op_status == 6">{{
                  $t("bank_card.Activated")
                }}</span>
                <span v-else-if="props.row.op_status == 7">{{
                  $t("bank_card.Printing")
                }}</span>
                <span v-else-if="props.row.op_status == 8">{{
                  $t("bank_card.freeze")
                }}</span>
                <span v-else-if="props.row.op_status == 9">{{
                  $t("bank_card.Cancelled")
                }}</span>
                <span v-else-if="props.row.op_status == 10">{{
                  $t("bank_card.mailed_s")
                }}</span>
                <span v-else-if="props.row.op_status == 11">{{
                  $t("bank_card.Card_anomaly")
                }}</span>
                <!-- <span v-else-if="props.row.op_status==12">{{$t('bank_card.Refuse_card')}}</span> -->
                <span v-else-if="props.row.op_status == 13">{{
                  $t("bank_card.Rep_card")
                }}</span>
                <span v-else-if="props.row.op_status == 14">{{
                  $t("bank_card.replacement_card")
                }}</span>
                <span v-else-if="props.row.op_status == 15">{{
                  $t("bank_card.Reissued_card")
                }}</span>
                <span v-else-if="props.row.op_status == 16">{{
                  $t("bank_card.Consolidating")
                }}</span>
                <span v-else-if="props.row.op_status == 17">{{
                  $t("bank_card.Pending_Rebind")
                }}</span>
                <span v-else-if="props.row.op_status == 18">{{
                  $t("bank_card.Cancelling")
                }}</span>
                <span v-else-if="props.row.op_status == 19">{{
                  $t("new3_txt.KYC_Rejected")
                }}</span>
                <span v-else>-</span>
                <el-tooltip placement="top" v-if="props.row.op_cause_type != 0">
                  <i class="el-icon-info warning_outline"></i>
                  <div slot="content">
                    <!-- op_cause_type 卡异常原因: 1丢失失窃；2损坏；3用户损坏；4工厂损坏；5激活失败；
                        6设置PIN失败；7派送问题； 8诈骗；9 邮错地址卡未退还；10邮错地址卡已退还 -->
                    <div v-if="props.row.op_cause_type == 1">
                      {{ $t("bank_card.op_cause_type1") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 2">
                      {{ $t("bank_card.op_cause_type2") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 3">
                      {{ $t("bank_card.op_cause_type3") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 4">
                      {{ $t("bank_card.op_cause_type4") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 5">
                      {{ $t("bank_card.op_cause_type5") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 6">
                      {{ $t("bank_card.op_cause_type6") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 7">
                      {{ $t("bank_card.op_cause_type7") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 8">
                      {{ $t("bank_card.op_cause_type8") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 9">
                      {{ $t("bank_card.op_cause_type9") }}
                    </div>
                    <div v-else-if="props.row.op_cause_type == 10">
                      {{ $t("bank_card.op_cause_type10") }}
                    </div>
                  </div>
                </el-tooltip>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.Remarks')" min-width="110">
              <span slot-scope="props">
                <div>{{ props.row.note }}</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.active_fail_reason')"
              min-width="110"
            >
              <span slot-scope="props">
                <!-- 激活失败原因 1:数据问题; 2:状态问题; 3:用户kyc未通过; 4:分配卡失败; 5:激活失败; 6设置pin失败; -->
                <div v-if="props.row.active_fail_reason == 1">
                  {{ $t("bank_card.data_problem") }}
                </div>
                <div v-else-if="props.row.active_fail_reason == 2">
                  {{ $t("bank_card.state_problem") }}
                </div>
                <div v-else-if="props.row.active_fail_reason == 3">
                  {{ $t("bank_card.User_kyc_failed") }}
                </div>
                <div v-else-if="props.row.active_fail_reason == 4">
                  {{ $t("bank_card.Allocation_card_failure") }}
                </div>
                <div v-else-if="props.row.active_fail_reason == 5">
                  {{ $t("bank_card.Activation_failure") }}
                </div>
                <div v-else-if="props.row.active_fail_reason == 6">
                  {{ $t("bank_card.Failed_set_pin") }}
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>

            <el-table-column
              :label="$t('bank_card.mail_address')"
              min-width="110"
            >
              <span slot-scope="props">
                <span class="next_info" @click="open_address(props.row)">{{
                  $t("bank_card.View")
                }}</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('change_status.issue')" min-width="110">
              <span slot-scope="props">
                <span
                  class="next_info"
                  v-if="props.row.card_issue_data.issue_transaction_id"
                  @click="open_issue(props.row)"
                  >{{ $t("bank_card.View") }}</span
                >
                <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column min-width="100" :label="$t('main.text593')">
              <span slot-scope="props">
                <div
                  v-if="props.row.method == 2 && props.row.check_status != 2"
                >
                  -
                </div>
                <div v-else>
                  <div v-if="props.row.balance">
                    {{ set_num3(props.row.balance) }}
                  </div>
                  <div v-else>-</div>
                </div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.operate')" min-width="180">
              <span slot-scope="props">
                <!-- bindStatus: 1, //0不可绑定也不可取消; 2绑定过了可以取消绑定; 3还没绑定，可以绑定 -->
                <!-- <div v-if="props.row.bindStatus==3" class="bing_btn next_info" @click="open_binding_card_dlg(props.row)">{{$t('bank_card.Bind')}}</div>
                <div v-else-if="props.row.bindStatus==2" class="bing_btn next_info" @click="unbind_btn(props.row)">{{$t('bank_card.unbind')}}</div>
                <div v-else>-</div> -->
                <!-- <div v-if="props.row.op_status==6" class="bing_btn next_info" @click="freeze(props.row.card_id)">{{$t('bank_card.freeze')}}</div> -->
                <template v-if="authjson.authjson(['9-14'])">
                  <div
                    v-if="props.row.status == 5"
                    class="bing_btn next_info"
                    @click="freeze(props.row.card_id)"
                  >
                    {{ $t("bank_card.freeze") }}
                  </div>
                </template>
                <!-- <div v-else-if="props.row.op_status==8&&[1,3].includes(props.row.block_orgin)" @click="thaw(props.row.card_id)" class="bing_btn next_info">{{$t('bank_card.thaw')}}</div> -->
                <template v-if="authjson.authjson(['9-14'])">
                  <div
                    v-if="
                      props.row.status == 6 &&
                      [1, 3].includes(props.row.block_orgin)
                    "
                    @click="thaw(props.row.card_id)"
                    class="bing_btn next_info"
                  >
                    {{ $t("bank_card.thaw") }}
                  </div>
                </template>
                <!-- <div v-else>-</div> -->
                <div
                  v-if="authjson.authjson(['9-10'])"
                  class="next_info"
                  @click="open_change_status_dlg(props.row.card_id)"
                >
                  {{ $t("bank_card.Modify_status") }}
                </div>

                <!-- status 状态 0未提交 1Pending, 2processing, 3approved，4rejected, 5active , 6blocked, 3显示激活，5显示充值 -->
                <!-- 卡状态  1Pending, 2processing, 3approved，4rejected, 5active , 6blocked 只有status 为5激活状态下可以修改密码 -->
                <!-- 2023-07-31 改成op_status 10 邮寄状态才可以 激活  -->
                <!-- 前台这个按钮先隐藏 activate 2023-08-25 -->
                <!-- <div v-if="props.row.op_status==10 && authjson.authjson(['9-7'])" class="next_info" @click="activate_btn(props.row.id)">{{$t('main.text625')}}</div> -->
                <!-- <div v-else-if="props.row.status==5 "> -->
                <div v-if="props.row.status == 5">
                  <div>
                    <div
                      class="next_info"
                      v-if="authjson.authjson(['9-16'])"
                      @click="top_up_btn(props.row.id, props.row.card_id)"
                    >
                      {{ $t("main.text626") }}
                    </div>
                  </div>
                  <div>
                    <div
                      class="next_info"
                      v-if="authjson.authjson(['9-17'])"
                      @click="reset_pin_btn(props.row.id)"
                      style="margin-top: 5px"
                    >
                      {{ $t("main.text705") }}
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    class="next_info"
                    v-if="[5,6,8,9].includes(props.row.status) && authjson.authjson(['9-18'])"
                    @click="transaction_list_btn(props.row.card_id)"
                    style="margin-top: 5px"
                  >
                    {{ $t("main.text270") }}
                  </div>
                </div>

              </span>
            </el-table-column>
          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 绑定卡 弹框 -->
    <!-- custom-class="dlg element_input add_dlg binding_dlg card_dlg_position" -->
    <el-dialog
      :title="$t('bank_card.binding_card')"
      :visible.sync="binding_card_dlg"
      custom-class="dlg element_input add_dlg binding_dlg"
      append-to-body
      width="80%"
    >
      <div class="dlg_body card_body">
        <div class="d_body">
          <el-table :data="card_tableData" stripe style="width: 100%">
            <el-table-column label="#" type="index" width="50">
            </el-table-column>
            <el-table-column :label="$t('bank_card.create_time')">
              <span slot-scope="props">
                <div>{{ overall_time2(props.row.create_time) }}</div>
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.order_id')">
              <span slot-scope="props">
                <div>{{ props.row.order_id }}</div>
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.branded_card_level')">
              <span slot-scope="props">
                <!-- "card_level": 1, 卡级别 1 Premier 2 Prestige -->
                {{ props.row.card_level_name }}
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.amount_num')">
              <span slot-scope="props">
                <div>{{ props.row.amount }}</div>
              </span>
            </el-table-column>
            <el-table-column :label="$t('main.text620')">
              <span slot-scope="props">
                <div>{{ props.row.remark }}</div>
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.state')">
              <!-- "status": 1, 状态 1待定(待接受) 2已接受(安排中) 3已取消 4部分分配 5完成分配  -->
              <span slot-scope="props">
                <span v-if="props.row.status == 1">{{
                  $t("bank_card.status_1")
                }}</span>
                <span v-else-if="props.row.status == 2">{{
                  $t("bank_card.status_2")
                }}</span>
                <span v-else-if="props.row.status == 3">{{
                  $t("bank_card.status_3")
                }}</span>
                <span v-else-if="props.row.status == 4">{{
                  $t("bank_card.status_4")
                }}</span>
                <span v-else-if="props.row.status == 5">{{
                  $t("bank_card.status_5")
                }}</span>
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.status_remark')">
              <span slot-scope="props">
                <div>{{ props.row.status_remark }}</div>
              </span>
            </el-table-column>
            <el-table-column :label="$t('bank_card.operate')">
              <span slot-scope="props">
                <!-- "status": 1, 状态 1待定(待接受) 2已接受(安排中) 3已取消 4部分分配 5完成分配  -->
                <div
                  v-if="props.row.status == 2 || props.row.status == 4"
                  class="select_btn"
                  @click="open_select_btn(props.row)"
                >
                  {{ $t("bank_card.select") }}
                </div>
              </span>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="card_tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="card_limit"
            :current-page.sync="card_currentPage"
            layout="prev, pager, next"
            :total="card_total"
            @current-change="card_current_change"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 已分配卡列表 弹框 -->
    <el-dialog
      :title="$t('bank_card.allocated_cards')"
      :visible.sync="allocated_cards_dlg"
      custom-class="dlg element_input add_dlg binding_dlg"
      append-to-body
      width="600"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-table :data="allocated_tableData" stripe style="width: 100%">
            <el-table-column label="#" type="index" width="50">
            </el-table-column>

            <el-table-column :label="$t('main.text142')">
              <span slot-scope="props">
                <div>{{ props.row.company_name }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.branded_card_category')">
              <span slot-scope="props">
                <!-- "card_type": 1, 1VISA 2 Mastercard 3 UnionPay -->
                <!-- <span>{{props.row.card_type}}</span> -->
                <span v-if="props.row.card_type == 1">{{
                  $t("bank_card.VISA")
                }}</span>
                <span v-else-if="props.row.card_type == 2">{{
                  $t("bank_card.Mastercard")
                }}</span>
                <span v-else-if="props.row.card_type == 3">{{
                  $t("bank_card.UnionPay")
                }}</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.branded_card_level')">
              <!-- "card_level": 1, 卡级别 1 Premier 2 Prestige -->
              <span slot-scope="props">
                <span>{{ props.row.card_level_name }}</span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.kit_number')">
              <span slot-scope="props">
                <div>{{ props.row.kit_number }}</div>
              </span>
            </el-table-column>

            <el-table-column :label="$t('bank_card.operate')">
              <span slot-scope="props">
                <div>{{ props.row.create_time }}</div>
                <!-- status: 1, //1已经绑定、0未绑定 -->
                <div
                  v-if="props.row.status == 0"
                  class="binding_btn"
                  @click="binding_click(props.row)"
                >
                  {{ $t("bank_card.Bind") }}
                </div>
                <div v-else>-</div>
              </span>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!-- 是否取消绑定 弹框 -->
    <el-dialog
      :visible.sync="Unbind_not"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out2 padding1">
        {{ $t("bank_card.is_unbind") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="Unbind_not = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button type="primary" class="apply_btn" @click="open_Unbind_not">{{
          $t("bank_card.confirm")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 冻结 弹框 -->
    <el-dialog
      :visible.sync="freeze_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out2 padding1">
        {{ $t("bank_card.Whether_freeze_account") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="freeze_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button type="primary" class="apply_btn" @click="freeze_confirm">{{
          $t("bank_card.confirm")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 运营状态  弹框 -->
    <el-dialog
      :visible.sync="change_status_dlg"
      custom-class="log_out_dlg_bgc card_foot"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out2 padding1">
        {{ $t("bank_card.Please_op_status") }}
      </div>

      <div class="block_value_box">
        <el-select
          v-model="op_status"
          :placeholder="$t('bank_card.Please_op_status')"
        >
          <!-- 运营状态1 Pending 2 KYC Processing 3 KYC Approved 4 Rejected 5 Card Binded 
              6 Activated 7 Printing 8 block 9 Cancelled 10 mailed  11 卡异常 12 拒绝补卡 13 申请补卡 
              14 补卡中 15 已补卡 16 Consolidating  -->
          <el-option
            :label="$t('bank_card.Card_anomaly')"
            :value="11"
          ></el-option>
        </el-select>
      </div>

      <div class="block_value_box">
        <el-select
          v-model="op_cause_type"
          :placeholder="$t('bank_card.Card_abnormal_cause')"
          v-if="op_status == 11"
          @change="op_status_change"
        >
          <!-- op_cause_type 卡异常原因: 1丢失失窃；2损坏；3用户损坏；4工厂损坏；5激活失败；
          6设置PIN失败；7派送问题； 8诈骗；9 邮错地址卡未退还；10邮错地址卡已退还 -->
          <el-option
            :label="$t('bank_card.op_cause_type1')"
            value="1"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type2')"
            value="2"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type3')"
            value="3"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type4')"
            value="4"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type5')"
            value="5"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type6')"
            value="6"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type7')"
            value="7"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type8')"
            value="8"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type9')"
            value="9"
          ></el-option>
          <el-option
            :label="$t('bank_card.op_cause_type10')"
            value="10"
          ></el-option>
        </el-select>
      </div>

      <div class="block_value_box" v-if="op_cause_type == 8">
        <div class="dlg_inp_box">
          <el-input
            v-model="issue.issue_transaction_id"
            :placeholder="$t('change_status.issue_transaction_id')"
          ></el-input>
        </div>
        <div class="dlg_inp_box">
          <el-date-picker
            :editable="false"
            popper-class="time_box"
            class="time_width"
            :clearable="false"
            v-model="issue.issue_date"
            type="date"
            :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
            value-format="timestamp"
            :placeholder="$t('change_status.issue_date')"
          >
          </el-date-picker>
        </div>
        <div class="dlg_inp_box">
          <el-input
            v-model="issue.issue_amount"
            :placeholder="$t('change_status.issue_amount')"
          ></el-input>
        </div>
        <div class="dlg_inp_box">
          <el-input
            v-model="issue.issue_merchant"
            :placeholder="$t('change_status.issue_merchant')"
          ></el-input>
        </div>
        <div class="dlg_inp_box">
          <el-input
            v-model="issue.issue_text"
            :placeholder="$t('change_status.issue_text')"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="change_status_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button
          type="primary"
          class="apply_btn"
          @click="change_status_dlg_confirm"
          >{{ $t("bank_card.confirm") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- ---------- -->
    <!-- 激活 填信息 弹框 -->
    <el-dialog
      :title="$t('main.text627')"
      :visible.sync="card_activate_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{ $t("main.text628") }}</div>
            <el-form-item :label="$t('main.text629')">
              <el-input v-model="card_digits"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text630')">
              <el-input v-model="card_id"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="card_activate_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="card_activate_submit"
          class="confirm_btn"
        >
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活成功 弹框 -->
    <el-dialog
      :visible.sync="card_activate_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text631") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text632") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="card_activate_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 第一次充值信息 弹框 -->
    <el-dialog
      :title="$t('main.text633')"
      :visible.sync="first_top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <!-- <div class="top_text2">{{ $t("main.text634") }}</div> -->
            <!-- 年费，卡费，激活卡的费用 如果扣除过了就不需要展示了
            手续费是每次都会展示的
            最大最小充值也需要都展示吧 -->
            <!-- <div class="info_1" v-if="top_up_config.annual_fee_status == 0">
              <div class="info_1_left">{{ $t("main.text503") }}</div>
              <div class="info_1_right">{{ top_up_config.annual_fee }}</div>
            </div>
            <div class="info_1" v-if="top_up_config.card_cost_status == 0">
              <div class="info_1_left">{{ $t("main.text504") }}</div>
              <div class="info_1_right">{{ top_up_config.card_cost }}</div>
            </div> -->
            <!-- 激活卡的费用 -->
            <div
              class="info_1"
              v-if="top_up_config.card_activation_status == 0"
            >
              <div class="info_1_left">{{ $t("main.text644") }}</div>
              <div class="info_1_right">
                {{ top_up_config.card_activation }}
              </div>
            </div>
            <!-- 手续费 -->
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text645") }}</div>
              <div class="info_1_right">{{ top_up_config.load_fee }}</div>
            </div>
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text635") }}</div>
              <div class="info_1_right">{{ top_up_config.min_top_up }}</div>
            </div>
            <!-- <div class="info_1">
              <div class="info_1_left">{{$t('main.text636')}}</div>
              <div class="info_1_right">{{top_up_config.max_top_up}}</div>
            </div> -->
            <!-- 转换费 -->
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.text695") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDTUSD) }} -->
                {{ top_up_config.usdt_usd_rate }}
              </div>
            </div>
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.text696") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDCUSD) }} -->
                {{ top_up_config.usdc_usd_rate }}
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="first_top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="first_top_up_next"
          class="confirm_btn"
        >
          {{ $t("main.text394") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值 弹框 -->
    <el-dialog
      :title="$t('main.text626')"
      :visible.sync="top_up_dlg"
      custom-class="dlg element_input add_dlg top_up_dlg"
      append-to-body
      top="5vh"
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text2">{{ $t("main.text637") }}</div>
            <div class="top_text3">{{ $t("main.text638") }}</div>
            <div class="amount_box">
              <div class="top_text4">{{ $t("main.text389") }}</div>
              <div class="top_text5 min_max_box">
                <div>
                  {{ $t("main.text650") }} ${{
                    dispose_num(top_up_config.min_top_up)
                  }}
                </div>
                <div>
                  {{ $t("top_up_dlg.Max_per") }} ${{
                    dispose_num(top_up_config.max_top_up)
                  }}
                </div>
              </div>
              <div class="top_text5">
                {{ $t("top_up_dlg.Current_Cap") }}${{
                  set_num3(top_up_config.now_balance_limit)
                }}
              </div>

              <div class="zdy_input box_margin">
                <el-input
                  v-model="input_v3_set"
                  placeholder=""
                  @blur="input3_set"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3').replace(/^\./g, '')"
                ></el-input>
                <div class="top_text7_2">USD</div>
              </div>

              <!-- 充值数量超过充值限额 警示框 红色 -->
              <div class="warning_red warning_yellow" v-show="warning_red_show">
                <div class="warning_red_icon warning_yellow_icon">
                  <i class="el-icon-warning"></i>
                </div>
                <div class="warning_red_text warning_yellow_text">
                  {{ $t("top_up_dlg.P_may") }}
                </div>
              </div>
              <!-- 余额不足  警示框 黄色 -->
              <!-- <div class="warning_red warning_yellow" v-show="warning_yellow_show">
                <div class="warning_red_icon warning_yellow_icon"><i class="el-icon-warning"></i></div>
                <div class="warning_red_text warning_yellow_text">
                  {{$t('main.text655')}}
                  {{select3}}
                  {{$t('main.text655_2')}}
                  <div>
                    <router-link :to="{ path: '/blockchain_d/deposit' }" class="top_up_link">{{$t('main.text656')}}</router-link>
                  </div>
                </div>
              </div> -->

              <div class="top_text4 top_text6">{{ $t("main.text741") }}</div>
              <!-- <div class="top_text7" v-show="usdt_num_show">USD {{usdt_num*1}}</div>result_num -->
              <div class="top_text7">
                <el-popover
                  width="170"
                  popper-class="bz_pop"
                  v-model="visible3"
                  trigger="click"
                >
                  <div slot="reference" class="type_box">
                    <div class="type_box1">
                      <img :src="set_name_img(select3)" alt="" />
                      <div class="type_box2">{{ select3 }}</div>
                    </div>
                    <div class="type_box3">
                      <i class="el-icon-caret-bottom"></i>
                    </div>
                  </div>
                  <div class="bz_list">
                    <div
                      class="type_box1 bz_list1"
                      v-for="(item, index) in currency_list3"
                      :key="index"
                      @click="select3_fun(item)"
                    >
                      <img :src="set_name_img(item)" alt="" />
                      <div class="type_box2">{{ item }}</div>
                    </div>
                  </div>
                </el-popover>
                <div class="div_num">{{ result_num * 1 }}</div>
              </div>

              <div class="top_text5 top_text5_2">
                {{ $t("main.text652") }}
                <span class="top_text10" v-if="select3 == 'BTC'"
                  >BTC = {{ set_num3(top_up_details.btc_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'ETH'"
                  >ETH = {{ set_num3(top_up_details.eth_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDT'"
                  >USDT = {{ set_num3(top_up_details.usdt_balance) }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDC'"
                  >USDC = {{ set_num3(top_up_details.usdc_balance) }}</span
                >
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text742") }}{{ select3 }} = {{ amount_crypto }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text743") }}{{ select3 }} = {{ fee_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text744") }}{{ select3 }} =
                {{ total_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text745") }}= {{ afterBalance }}
              </div>
            </div>
            <div>
              <div class="top_text4 top_text6">
                {{ $t("main.text514") }} ({{
                  top_up_config.contract_card_name
                }})
              </div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text567") }}</div>
                <div class="top_text10">{{ top_up_details.card_name }}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text658") }}</div>
                <div class="top_text10">
                  {{
                    top_up_details.number
                      ? "****" + top_up_details.number.substr(-4)
                      : "-"
                  }}
                </div>
              </div>
              <div class="top_text8">
                <div class="top_text9">
                  {{ $t("main.text255") }}
                  <!-- <br/>({{$t('main.text659')}} = {{top_up_details.card_limit}}) -->
                </div>
                <div class="top_text10">USD {{ top_up_details.balance }}</div>
              </div>
            </div>

            <div>
              <div class="top_text4 top_text6">
                {{ $t("top_up_dlg.Source_fund") }}
              </div>
              <div class="top_text8">
                <el-select v-model="t_up_select" style="width: 100%">
                  <el-option
                    :label="$t('top_up_dlg.E_Income')"
                    value="Employment Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.I_Income')"
                    value="Investment Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.B_Income')"
                    value="Business Income"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Savings')"
                    value="Savings"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Loans')"
                    value="Loans"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Sales_I')"
                    value="Sales of Investment"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Gifts')"
                    value="Gifts"
                  ></el-option>
                  <el-option
                    :label="$t('top_up_dlg.Others')"
                    value="Others"
                  ></el-option>
                </el-select>
              </div>
              <div class="top_text4 top_text6" v-if="t_up_select == 'Others'">
                {{ $t("top_up_dlg.Others") }}
              </div>
              <div class="top_text8" v-if="t_up_select == 'Others'">
                <el-input
                  v-model="t_up_others"
                  placeholder=""
                  style="width: 100%"
                ></el-input>
              </div>
              <div class="top_text8">
                <el-checkbox v-model="read_protocol" class="tup_checkbox">
                  {{ $t("top_up_dlg.I_confirm") }}
                </el-checkbox>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="top_up_submit" class="confirm_btn">
          {{ $t("main.text36") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值成功 弹框 -->
    <el-dialog
      :visible.sync="top_up_success_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
      @close="go_list"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ t_up_title }}
      </div>
      <div class="log_out3 padding2">
        {{ t_up_msg }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="top_up_success_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 充值失败 弹框 -->
    <el-dialog
      :visible.sync="top_up_error_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img style="width: 35px" src="../../assets/img/error_icon.png" alt="" />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text641") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text642") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="top_up_error_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button type="primary" class="apply_btn" @click="card_topUp_fun">{{
          $t("main.text643")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 重置联名卡密码 弹框 -->
    <el-dialog
      :title="$t('main.text705')"
      :visible.sync="reset_pwd_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('main.text706')">
              <el-input
                v-model="new_pin"
                :type="pwdType == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>

              <div class="btm_text">{{ $t("main.text707") }}</div>
            </el-form-item>
            <el-form-item :label="$t('main.text708')">
              <el-input
                v-model="confirm_new_pin"
                :type="pwdType2 == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="reset_pwd_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="reset_pwd_submit" class="confirm_btn">
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 地址信息 弹框 -->
    <el-dialog
      :title="$t('bank_card.Card_mailing_address')"
      :visible.sync="addr_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="480px"
    >
      <div class="addr_txt">
        {{ $t("bank_card.Mail_Address_Line") }} : {{ addr_data.mail_address }}
      </div>
      <div class="addr_txt">
        {{ $t("bank_card.Mail_Address_Line2") }} :
        {{ addr_data.mail_secondary_address }}
      </div>
      <div class="addr_txt">
        {{ $t("bank_card.Mail_City") }} : {{ addr_data.mail_city }}
      </div>
      <div class="addr_txt">
        {{ $t("bank_card.Mail_State") }} : {{ addr_data.mail_state }}
      </div>
      <div class="addr_txt">
        {{ $t("bank_card.Mail_Country") }} : {{ addr_data.country }}
      </div>
      <!-- <div class="addr_txt">{{$t('bank_card.Mail_Postal_Code')}} : {{ addr_data.mail_postal_code }}</div> -->
      <div class="addr_txt">
        {{ $t("main.text199") }} : +{{ addr_data.mail_postal_code }}
        {{ addr_data.mobile_number }}
      </div>

      <span slot="footer" class="dialog-footer"> &nbsp; </span>
    </el-dialog>

    <!-- 卡盗刷信息 弹框 -->
    <el-dialog
      :title="$t('change_status.issue')"
      :visible.sync="issue_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="480px"
    >
      <div class="addr_txt">
        {{ $t("change_status.issue_transaction_id") }} :
        {{ issue_data.issue_transaction_id }}
      </div>
      <div class="addr_txt">
        {{ $t("change_status.issue_date") }} :
        {{ overall_time2(issue_data.issue_date) }}
      </div>
      <div class="addr_txt">
        {{ $t("change_status.issue_amount") }} : {{ issue_data.issue_amount }}
      </div>
      <div class="addr_txt">
        {{ $t("change_status.issue_merchant") }} :
        {{ issue_data.issue_merchant }}
      </div>
      <div class="addr_txt">
        {{ $t("change_status.issue_text") }} :
        {{ issue_data.issue_text || "-" }}
      </div>

      <span slot="footer" class="dialog-footer"> &nbsp; </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  cardList,
  orderListByCardInfo,
  unassignedList,
  preallocation_bind,
  preallocation_unbind,
  block,
  unblock,
  modifyOpStatus,
  card_active,
  card_topUp,
  card_getTopUpConfig,
  card_calc,
  refreshData,
  setPin,
  getConfigData,
  cardListDownload,
} from "@/api/api";
import BigNumber from "bignumber.js";
// import { debounce } from "@/utils/util.js";

export default {
  data() {
    return {
      currentPage: 1,
      page: 0, //分页 从 1 开始
      limit: 10, //每页条数
      total: 0, //一共多少条
      // card_level:'',//卡级别 1Premier 2Premium
      // card_category:'',//1VISA 2Mastercard 3UnionPay
      tableData: [],
      form: {
        card_name: "", //	String	持卡人姓名
        card_email: "", //	String	持卡人邮箱
        company_name: "", //	String	公司名称
        kyc_status: "", //	Number	KYC 状态 暂定
        op_status: "", //	运营状态
        card_level: "", //	Number	卡级别 1Premier 2Premium
        card_category: "", //	Number	1VISA 2Mastercard 3UnionPay
        card_number: "", //	String	卡号
        print_number: "", //打印批号
        username: "",
        kit_number: "",
        visionLife_id: "",
        account_status:'',
        card_status:"",
      },
      binding_card_dlg: false,
      allocated_cards_dlg: false,
      // card_id:'',
      card_currentPage: 1,
      card_page: 0,
      card_limit: 10,
      card_total: 0,
      card_tableData: [],
      unbind_data: {},
      Unbind_not: false,
      allocated_tableData: [],
      id1: "",
      freeze_card_id: "",
      freeze_dlg: false,
      change_status_dlg: false,
      op_status: 11,
      change_status_dlg_id: "",
      op_cause_type: "",
      // ----------
      card_activate_dlg: false,
      card_digits: "",
      card_id: "",
      card_activate_ok_dlg: false,
      first_top_up_dlg: false,
      top_up_dlg: false,

      visible3: false,
      select3: "USDT",
      input_v3: "",
      input_v3_set: "",
      inp3_ratio: "",

      // currency_list3:["BTC","ETH","USDT","USDC"],
      currency_list3: ["USDT", "USDC"],

      // 币种 图标
      icon_list: {
        ETH: require("../../assets/img/ETH.png"),
        USDT: require("../../assets/img/USDT.png"),
        BTC: require("../../assets/img/BTC.png"),
        USDC: require("../../assets/img/USDC.png"),
        USD: require("../../assets/img/USD.png"),
        CNY: require("../../assets/img/CNY.png"),
        SGD: require("../../assets/img/SGD.png"),
        GBP: require("../../assets/img/GBP.png"),
        AUD: require("../../assets/img/AUD.png"),
        HKD: require("../../assets/img/HKD.png"),
      },
      top_up_success_dlg: false,
      top_up_error_dlg: false,
      top_up_config: "",
      top_up_id: "",
      activate_card_id: "",
      top_up_details: "",
      rateConfig: "",
      usdt_num: "",
      usdt_num_show: false,
      account_num: "",
      warning_red_show: false,
      warning_yellow_show: false,
      result_num: "",

      reset_pwd_dlg: false,
      new_pin: "",
      confirm_new_pin: "",
      reset_pin_id: "",

      pwd_yes: require("../../assets/img/eye_no_b.png"),
      pwd_no: require("../../assets/img/eye_yes_b.png"),
      pwdType: true,
      pwdType2: true,
      amount_crypto: 0,
      fee_crypto_amount: 0,
      total_crypto_amount: 0,
      afterBalance: 0,

      card_array_list: [],
      card_level_list: [],
      card_type_list: [],
      card_array: "",
      card_level: "",
      card_type: "",
      addr_dlg: false,
      addr_data: {},
      company_type: sessionStorage.getItem("company_type"),

      t_up_select: "",
      t_up_others: "",
      read_protocol: false,
      deposit_amount: "", //充值数量
      t_up_title: "",
      t_up_msg: "",
      issue: {
        issue_transaction_id: "",
        issue_date: "",
        issue_amount: "",
        issue_merchant: "",
        issue_text: "",
      },
      issue_data: {},
      issue_dlg: false,
      project_name: sessionStorage.getItem("project_name"),
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", " ");
    this.company_type = sessionStorage.getItem("company_type");
    this.project_name = sessionStorage.getItem("project_name");
    this.get_list();
    this.get_config_data();
  },
  methods: {
    dispose_num(v) {
      if (v) {
        return this.set_num3(parseFloat(v.replace(/[^\d\\.-]/g, "")));
      }
    },
    async get_list() {
      const res = await cardList({
        page: this.page,
        limit: this.limit,
        card_name: this.form.card_name,
        card_email: this.form.card_email,
        company_name: this.form.company_name,
        status: this.form.kyc_status,
        op_status: this.form.op_status,
        card_array: this.card_array,
        card_level: this.card_level,
        card_category: this.card_type,
        card_number: this.form.card_number,
        print_number: this.form.print_number,
        username: this.form.username,
        kit_number: this.form.kit_number,
        visionLife_id: this.form.visionLife_id,
        account_status: this.form.account_status,
        card_status: this.form.card_status,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      // console.log(res.data.data);
      this.total = res.data.data.count;
      this.tableData = res.data.data.list;
    },
    async get_config_data() {
      const res = await getConfigData();
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.card_array_list = res.data.data.card_array;
      this.card_level_list = res.data.data.card_level;
      this.card_type_list = res.data.data.card_type;
    },
    current_change(v) {
      this.page = v - 1;
      this.limit = 10;
      this.get_list();
    },
    card_current_change(v) {
      this.page = v - 1;
      this.limit = 10;
      this.get_list();
    },
    reset_btn() {
      (this.form = {
        card_name: "", //	String	持卡人姓名
        card_email: "", //	String	持卡人邮箱
        company_name: "", //	String	公司名称
        kyc_status: "", //	Number	KYC 状态 暂定
        card_level: "", //	Number	卡级别 1Premier 2Premium
        card_category: "", //	Number	1VISA 2Mastercard 3UnionPay
        card_number: "", //	String	卡号
        print_number: "",
        username: "",
        kit_number: "",
        visionLife_id: "",
        account_status:'',
        card_status:'',
      }),
        (this.card_array = "");
      this.card_level = "";
      this.card_type = "";
      this.page = 0;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      this.page = 0;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    to_info(name) {
      this.$router.push({
        path: "/card_management_info",
        query: { name: name },
      });
    },
    async open_binding_card_dlg(row) {
      this.id1 = row.card_id;
      const res = await orderListByCardInfo({
        page: this.card_page,
        limit: this.card_limit,
        card_level: row.card_level,
        card_category: row.card_category,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      // console.log(res.data.data);
      this.card_total = res.data.data.count;
      this.card_tableData = res.data.data.list;

      this.binding_card_dlg = true;
    },
    async binding_click(row) {
      // console.log(row);
      const res = await preallocation_bind({
        operator: sessionStorage.getItem("userid"),
        kit_number: row.kit_number,
        card_id: this.id1,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage("success", this.$t("bank_card.bind_success"));
      // console.log(res.data.data);
      this.allocated_cards_dlg = false;
      this.binding_card_dlg = false;
      this.get_list();
    },
    async open_select_btn(row) {
      const res = await unassignedList({
        order_id: row.order_id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.allocated_tableData = res.data.data.list;
      this.allocated_cards_dlg = true;
    },
    unbind_btn(row) {
      this.unbind_data = row;
      this.Unbind_not = true;
    },
    async open_Unbind_not() {
      const res = await preallocation_unbind({
        operator: sessionStorage.getItem("userid"),
        card_id: this.unbind_data.card_id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage("success", this.$t("bank_card.unbind_success"));
      this.Unbind_not = false;
      this.get_list();
    },
    freeze(id) {
      this.freeze_card_id = id;
      this.freeze_dlg = true;
    },
    async freeze_confirm() {
      const res = await block({
        card_id: this.freeze_card_id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage("success", this.$t("bank_card.Freezing_success"));
      this.freeze_dlg = false;
      this.get_list();
    },
    async thaw(id) {
      const res = await unblock({
        card_id: id,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage(
        "success",
        this.$t("bank_card.Successful_thawing")
      );
      this.get_list();
    },

    open_change_status_dlg(id) {
      this.change_status_dlg_id = id;
      // this.op_status='';
      this.op_cause_type = "";

      this.issue.issue_transaction_id = "";
      this.issue.issue_date = "";
      this.issue.issue_amount = "";
      this.issue.issue_merchant = "";
      this.issue.issue_text = "";
      this.change_status_dlg = true;
    },
    async change_status_dlg_confirm() {
      if (!this.op_status) {
        return this.message.ismessage(
          "error",
          this.$t("bank_card.Please_op_status")
        );
      }
      if (this.op_status == 11 && !this.op_cause_type) {
        return this.message.ismessage(
          "error",
          this.$t("bank_card.Select_card_cause")
        );
      }
      if (this.op_cause_type == 8) {
        if (!this.issue.issue_transaction_id) {
          return this.message.ismessage(
            "error",
            this.$t("change_status.issue_transaction_id")
          );
        }
        if (!this.issue.issue_date) {
          return this.message.ismessage(
            "error",
            this.$t("change_status.issue_date")
          );
        }
        if (!this.issue.issue_amount) {
          return this.message.ismessage(
            "error",
            this.$t("change_status.issue_amount")
          );
        }
        if (!this.issue.issue_merchant) {
          return this.message.ismessage(
            "error",
            this.$t("change_status.issue_merchant")
          );
        }
      }
      const res = await modifyOpStatus({
        card_id: this.change_status_dlg_id,
        op_status: this.op_status,
        op_cause_type: this.op_cause_type || "0",
        issue_transaction_id: this.issue.issue_transaction_id,
        issue_date: this.issue.issue_date,
        issue_amount: this.issue.issue_amount,
        issue_merchant: this.issue.issue_merchant,
        issue_text: this.issue.issue_text,
      });
      if (res.data.code !== 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.message.ismessage("success", this.$t("main.text215"));
      this.change_status_dlg = false;
      this.get_list();
    },
    op_status_change() {
      if (this.op_status != 11) {
        this.op_cause_type = 0;
      }
      if (this.op_cause_type != 8) {
        this.issue.issue_date = "";
        this.issue.issue_amount = "";
        this.issue.issue_merchant = "";
        this.issue.issue_text = "";
      }
    },
    // ----------
    activate_btn(id) {
      this.card_digits = "";
      this.card_id = "";
      this.card_activate_dlg = true;
      this.activate_card_id = id;
      // console.log(this.activate_card_id);
    },
    card_activate_submit() {
      if (!this.card_digits.trim() || this.card_digits.length !== 16) {
        return this.message.ismessage("error", this.$t("main.text660"));
      }
      if (!this.card_id.trim()) {
        return this.message.ismessage("error", this.$t("main.text661"));
      }
      card_active({
        id: this.activate_card_id,
        number: this.card_digits,
        card_id: this.card_id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_activate_dlg = false;
          this.card_activate_ok_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    top_up_btn(id, card_id) {
      // this.first_top_up_dlg=true;
      this.card_id = card_id;
      this.top_up_id = id;
      this.get_top_up_config(card_id);
    },
    first_top_up_next() {
      this.first_top_up_dlg = false;
      this.top_up_dlg = true;
      this.input_v3 = "";
      this.input_v3_set = "";
      this.usdt_num_show = false;
      this.warning_red_show = false;
      this.warning_yellow_show = false;
      this.t_up_select = "";
      this.t_up_others = "";
      this.read_protocol = false;
    },
    top_up_submit() {
      if (!this.input_v3.trim()) {
        return this.message.ismessage("error", this.$t("main.text389"));
      }
      // if (this.usdt_num <= this.account_num) {
      //   return this.message.ismessage('error',this.$t('main.text662'));
      // }

      // if((this.input_v3)*1 > ((this.top_up_config.max_top_up).substr(1))*1){
      //   return this.warning_red_show=true;
      // }else{
      //   this.warning_red_show=false;
      // }

      // select3== BTC 'ETH' USDT USDC
      // if(this.select3=="BTC"){
      //   if((this.input_v3)*1 > this.top_up_details.btc_balance){
      //     return this.warning_yellow_show=true;
      //   }else{
      //     this.warning_yellow_show=false;
      //   }
      // }else if(this.select3=="ETH"){
      //   if((this.input_v3)*1 > (this.top_up_details.eth_balance)*1){
      //     return this.warning_yellow_show=true;
      //   }else{
      //     this.warning_yellow_show=false;
      //   }
      // }else if(this.select3=="USDT"){
      //   if((this.input_v3)*1 > (this.top_up_details.usdt_balance)*1){
      //     return this.warning_yellow_show=true;
      //   }else{
      //     this.warning_yellow_show=false;
      //   }
      // }else if(this.select3=="USDC"){
      //   if((this.input_v3)*1 > (this.top_up_details.usdc_balance)*1){
      //     return this.warning_yellow_show=true;
      //   }else{
      //     this.warning_yellow_show=false;
      //   }
      // }

      // if (this.usdt_num < (this.top_up_config.min_top_up).substr(1)*1) {
      //   return this.message.ismessage('error',this.$t('main.text663'));
      // }
      // if (this.usdt_num > (this.top_up_config.max_top_up).substr(1)*1) {
      //   return this.message.ismessage('error',this.$t('main.text664'));
      // }

      this.card_topUp_fun();
    },
    card_topUp_fun() {
      if (!this.t_up_select) {
        return this.message.ismessage(
          "error",
          this.$t("top_up_dlg.Source_fund")
        );
      }
      let fund_source = this.t_up_select;
      if (this.t_up_select == "Others") {
        if (!this.t_up_others) {
          return this.message.ismessage("error", this.$t("top_up_dlg.Others"));
        } else {
          fund_source = this.t_up_others;
        }
      }
      if (!this.read_protocol) {
        return this.message.ismessage(
          "error",
          this.$t("top_up_dlg.Please_check")
        );
      }

      card_topUp({
        card_id: this.card_id,
        token_type: this.select3,
        amount: this.input_v3,
        fund_source,
      }).then((res) => {
        if (res.data.code == 200) {
          // this.message.ismessage('success',res.data.msg);
          this.top_up_dlg = false;
          this.get_list();
          this.t_up_title = res.data.title;
          this.t_up_msg = res.data.msg;
          this.top_up_success_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
          this.top_up_error_dlg = true;
        }
      });
    },
    input3_set(e) {
      let v = e.target.value;
      this.input_v3 = v;
      this.input_v3_set = this.set_num3_2(v * 1);
      this.set_usd_num(v);
    },
    select3_fun(v) {
      this.select3 = v;
      this.visible3 = false;
      if (this.input_v3) {
        this.set_usd_num(this.input_v3);
      }
    },
    set_name_img(v) {
      if (v.indexOf("-") != -1) {
        let str1 = v.split("-")[0];
        return this.icon_list[str1];
      } else {
        return this.icon_list[v];
      }
    },
    // 设置key 对应接口 key
    set_api_key(v) {
      if (v.indexOf("-") != -1) {
        return v.toLowerCase().replace("-", "_");
      } else {
        return v.toLowerCase();
      }
    },
    get_top_up_config(card_id) {
      // 获取充值配置
      card_getTopUpConfig({ card_id }).then((res) => {
        if (res.data.code == 200) {
          this.top_up_config = res.data.data;
          this.top_up_details = res.data.details;
          this.rateConfig = res.data.details.rateConfig;
          // console.log(this.top_up_config);
          // console.log(this.top_up_details);

          this.result_num = "";
          this.select3 = "USDT";
          this.amount_crypto = 0;
          this.fee_crypto_amount = 0;
          this.total_crypto_amount = 0;
          this.afterBalance = 0;
          this.first_top_up_dlg = true;
        }
      });
    },
    // 计算 用户输入 转换usd
    set_usd_num(v) {
      if (v) {
        if (this.input_v3 * 1 > this.top_up_config.recharge_warning * 1) {
          this.warning_red_show = true;
        } else {
          this.warning_red_show = false;
        }

        let _this = this;
        // debounce(function(){
        card_calc({
          card_id: _this.card_id,
          token_type: _this.select3,
          amount: v,
        }).then((res) => {
          if (res.data.code == 200) {
            _this.result_num = res.data.data.total_crypto_amount;
            _this.amount_crypto = res.data.data.amount_crypto;
            _this.fee_crypto_amount = res.data.data.fee_crypto_amount;
            _this.total_crypto_amount = res.data.data.total_crypto_amount;
            _this.afterBalance = res.data.data.afterBalance;
          } else {
            _this.message.ismessage("error", res.data.msg);

            _this.result_num = 0;
            _this.amount_crypto = 0;
            _this.fee_crypto_amount = 0;
            _this.total_crypto_amount = 0;
            _this.afterBalance = 0;
          }
        });
        // },1000);
      }
    },
    // 刷新
    refresh_btn() {
      refreshData({
        page: this.page,
        limit: this.limit,
        card_name: this.form.card_name,
        card_email: this.form.card_email,
        company_name: this.form.company_name,
        status: this.form.kyc_status,
        op_status: this.form.op_status,
        card_array: this.card_array,
        card_level: this.card_level,
        card_category: this.card_type,
        card_number: this.form.card_number,
        print_number: this.form.print_number,
        username: this.form.username,
        kit_number: this.form.kit_number,
        visionLife_id: this.form.visionLife_id,
        account_status: this.form.account_status,
        card_status: this.form.card_status,
      }).then((res) => {
        if (res.data.code == 200) {
          this.get_list();
          this.message.ismessage("success", this.$t("main.text673"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    reset_pin_btn(id) {
      this.reset_pin_id = id;
      this.new_pin = "";
      this.confirm_new_pin = "";
      this.reset_pwd_dlg = true;
    },
    reset_pwd_submit() {
      if (!this.new_pin)
        return this.message.ismessage("error", this.$t("main.text705"));
      if (!this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text706"));
      if (this.new_pin.length < 4 || this.confirm_new_pin.length < 4)
        return this.message.ismessage("error", this.$t("main.text707"));
      if (this.new_pin !== this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text209"));
      setPin({
        id: this.reset_pin_id,
        pin: this.new_pin,
        confirm_pin: this.confirm_new_pin,
      }).then((res) => {
        if (res.data.code == 200) {
          this.reset_pwd_dlg = false;
          this.get_list();
          this.message.ismessage("success", this.$t("main.text215"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    set_num_fee(v) {
      let d = BigNumber(1).minus(v).times(100);
      return d + "%";
    },
    transaction_list_btn(id) {
      this.$router.push({ path: "/transaction_record", query: { id } });
    },
    go_list() {
      this.$router.push("/top_up_history");
    },
    open_address(row) {
      this.addr_data = row;
      this.addr_dlg = true;
      // console.log(row);
    },
    open_issue(row) {
      // console.log(row.card_issue_data);
      this.issue_data = row.card_issue_data;
      this.issue_dlg = true;
    },
    download_btn() {
      if (this.total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      cardListDownload({
        card_name: this.form.card_name,
        username: this.form.username,
        card_email: this.form.card_email,
        company_name: this.form.company_name,
        status: this.form.kyc_status,
        op_status: this.form.op_status,
        card_array: this.card_array,
        card_level: this.card_level,
        card_category: this.card_type,
        card_number: this.form.card_number,
        print_number: this.form.print_number,
        kit_number: this.form.kit_number,
        visionLife_id: this.form.visionLife_id,
        account_status: this.form.account_status,
        card_status: this.form.card_status,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style scoped>
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red {
  color: #f35f65;
}
.zdy_tab_header >>> .el-table tr th:last-child,
.zdy_tab_header >>> .el-table__body tr td:last-child {
  padding-left: 0 !important;
}
.btn_icon {
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1 {
  height: 32px;
  border: 1px solid #deb981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2 {
  height: 32px;
  border: 1px solid #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ff4646;
  background: transparent;
  margin-top: 10px;
}
.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active {
  background: #f35f65;
  border-color: #f35f65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}
.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}
.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text5_2:nth-child(8) {
  padding-top: 10px;
}
.top_text5_2 {
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7 {
  /* padding: 18px 12px 20px;
  background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.div_num {
  flex: 1;
  background: #223c58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2 {
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}
.top_text8 {
  display: flex;
  margin-top: 12px;
}
.top_text8 > div {
  width: 50%;
}
.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow {
  background: #e8dac8;
}
.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}
.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}
.top_up_link {
  color: #041728;
  text-decoration: underline;
}
.yellow {
  color: #d9b680;
  cursor: pointer;
  margin-right: 10px;
}

.min_max_box {
  display: flex;
  justify-content: space-between;
}
.tup_checkbox,
.tup_checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
  white-space: pre-wrap;
  display: flex;
}
</style>

<style>
.top_up_dlg {
  max-height: 95vh;
  overflow-y: auto;
}
.top_up_dlg::-webkit-scrollbar {
  width: 5px;
}
.top_up_dlg::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #f1c788;
}

.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell {
  background: #172c43 !important;
}
.cards_table .row_2_bgc:hover {
  background: #172c43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell {
  background: #172c43 !important;
}
/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text {
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}

.c_top_title {
  font-size: 16px;
  margin-bottom: 20px;
}
.num_item {
  box-sizing: border-box;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #314b69;
}
.num_item div {
  margin-bottom: 7px;
}
.num_item div:last-child {
  margin-bottom: 0;
}
.c_top_num_box .num_item {
  margin-right: 20px;
}
.c_top_num_box .num_item:last-child {
  margin-right: 0;
}
.el-input.is-disabled .el-input__inner {
  color: #000;
}
.bing_btn {
  cursor: pointer;
}
.select_btn {
  cursor: pointer;
  color: #11b8a6;
}
.binding_btn {
  cursor: pointer;
  color: #a2ef4d;
}
.next_info {
  cursor: pointer;
  color: #f1c788;
}
.card_body {
  max-height: 80vh;
  overflow-y: auto;
}
.icon_question {
  margin-left: 5px;
  cursor: pointer;
}
.block_value_box {
  text-align: center;
  margin: auto;
  margin-top: 30px;
  width: 75%;
}
.block_value_box .el-input__inner,
.block_value_box .el-range-input {
  background: #223c58;
  border: none;
  /* border-radius: 8px; */
  color: #fff;
  padding-left: 15px;
}
.dlg_inp_box {
  margin-top: 30px;
}
.block_value_box .el-select,
.time_width {
  width: 100% !important;
}
.card_foot {
  padding-bottom: 20px;
}
.warning_outline {
  cursor: pointer;
  margin-left: 5px;
}
.addr_txt {
  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  box-sizing: border-box;
  padding: 0 27px;
  color: #ffffff;
  opacity: 0.9;
  margin-top: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
</style>

<style>
.binding_dlg .d_body {
  max-width: 95% !important;
  margin: auto !important;
  padding-top: 0 !important;
}
/* @media screen and (max-height: 757px) {
  .card_dlg_position{
    top: 0 !important;
    transform: translate(-50%, 0) !important;
  }
} */
.card_foot .el-dialog__footer {
  padding-bottom: 30px;
}
.tooltip_w {
  max-width: 200px;
  word-wrap: break-word;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  .num_item {
    width: 100%;
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>
